import { useQuery } from "react-query";

import { useReactAppState } from "../../shared/containers/utils";
import { d3PlayerStatsAPI } from "../../shared/api/variables";
import { fetchClient } from "../../shared/api/fetching";
import { cardTypes, formatPlayerStats } from "../../shared/utils";

function useMLSPlayerStatistics({ competitionSportecId, seasonSportecId, sortColumn, cardType, queryOptions = {}, formatPlayers = true ,clubSportecId}) {
    const { apiList } = useReactAppState();
    const { d3SportsAPI } = apiList || {};

    const endpoint = d3PlayerStatsAPI({ competitionSportecId, seasonSportecId, sortColumn, sortOrder: 'desc', pageSize: 5, clubSportecId });
    const isCardTypePlayer = cardType === cardTypes.player;

    return useQuery({
        queryKey: ["d3-player-statistics", competitionSportecId, seasonSportecId, sortColumn],
        queryFn: () => fetchClient({ endpoint, apiURL: d3SportsAPI }),
        enabled: isCardTypePlayer && !!competitionSportecId && !!seasonSportecId && !!sortColumn,
        select: (data) => {
            return data?.map((playerStatistics) => {
                return formatPlayers ? formatPlayerStats(playerStatistics) : playerStatistics;
            });
        },
        ...queryOptions
    });
}

export default useMLSPlayerStatistics;
